export const NAV_KEY = 'reset-filter';
export const TITLE = 'Reset Filters';
export const SUBTITLE = 'Are you sure you want to reset all applied filters?';
export const RESET = 'Reset';
export const CANCEL = 'Cancel';
export const CROSS_ICON_SIZE = '18px';
